/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const headerMiniCartContainerSX: SxProps = {
	position: 'relative',
};

export const numberCountCartSX = ({ isMobile }: { isMobile?: boolean }): SxProps => ({
	fontSize: isMobile ? '14px' : '12px',
	fontWeight: 'bold',
	color: '#011688',
	letterSpacing: '0px',
	position: 'absolute',
	top: isMobile ? '-14px' : '-14px',
});

export const iconCountCartSX = ({
	isMobile,
	isItemsCount,
}: {
	isMobile?: boolean;
	isItemsCount?: boolean;
}): SxProps => ({
	color: isItemsCount ? '#011688' : '#2C2C2C',
	fontSize: isMobile ? '23px' : '21px',
});
